import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import CustomLink from '../Components/Layout/CustomLink'
import GetStarted from '../Components/Home/GetStarted'
import '../Components/Home/GetStarted/GetStarted.css'
import IntroPic from '../Components/Home/IntroPic'
import TypeNav from '../Components/Home/TypeNav'
import HomeContact from '../Components/Home/HomeContact'

export interface TypesMenuObj {
  key: number
  label: string
  description: string
}


const Home = () => {
  const baseUrl: string = `${process.env.REACT_APP_URL}`
  const [setType, setTypeItem] = useState<TypesMenuObj[]>([])

  return (
    <div className="bg-image">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home</title>
        <link rel="canonical" href={baseUrl + '/'} />
      </Helmet>
      <div className="container">
        <TypeNav setType={setType} setTypeItem={setTypeItem}/>
        <IntroPic />
      </div>
      <div className="started-home">

        <GetStarted />
      </div>
        <div className="bg-image">
        <HomeContact />
        </div>
      
    </div>
  )
}
export default Home




